import { createContext } from 'react';
var likesContext = /*#__PURE__*/createContext({
  allLikes: {},
  hasLikes: {},
  setInitialLikes: function setInitialLikes() {},
  setUpdatedLikes: function setUpdatedLikes() {},
  checkLikes: function checkLikes() {},
  updateLikes: function updateLikes() {}
});
export default likesContext;